import { ChevronRight, Sparkles } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { TrackedButton } from '@Components/ui-v2/tracked-button';
import './PersonalizeCard.css';

interface PersonalizeCardProps {
  onClick?: () => void;
}

const PersonalizeCard = ({ onClick }: PersonalizeCardProps) => {
  const { t } = useTranslation();

  return (
    <div className="agent-personalize-card">
      <TrackedButton
        type="button"
        variant="ghost"
        buttonName="AGENT_PERSONALIZE_OPEN"
        onClick={onClick}
        className="group relative z-[2] flex h-auto w-full items-center justify-start gap-3 whitespace-normal rounded-[14px] bg-transparent px-4 py-3 text-left cursor-pointer transition-all duration-200 hover:bg-transparent active:scale-[0.99]">
        <span
          className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg"
          style={{ backgroundColor: 'rgba(124, 108, 246, 0.12)', color: '#7c6cf6' }}
          aria-hidden>
          <Sparkles size={15} strokeWidth={1.75} />
        </span>
        <span className="flex-1">
          <span className="block text-sm font-medium" style={{ color: '#5B4BD6' }}>
            {t('Agent.PreferencesBannerHighlight')}
          </span>
          <span className="block text-xs text-gray-500">{t('Agent.PersonalizeSubtitle')}</span>
        </span>
        <ChevronRight
          size={14}
          strokeWidth={1.75}
          className="flex-shrink-0 text-gray-300 transition-all duration-200 group-hover:translate-x-0.5 group-hover:text-gray-500"
          aria-hidden
        />
      </TrackedButton>
    </div>
  );
};

export default PersonalizeCard;
